module.exports = __webpack_public_path__ + "static/media/key_icon.3e08f305.svg";